import { ALL_ORDERS } from "@/components/pii-backfill/backfill-settings";
import { Button } from "@babackapp/ui/components/button";
import { Input } from "@babackapp/ui/components/input";
import {
  ALL_STATUSES,
  type BackfillFilters,
  SHOW_COVERED,
} from "./pii-backfill-row-filter";
import { BACKFILL_STATUSES } from "./pii-backfill-summary";

const COVERED_OPTIONS = [
  { value: SHOW_COVERED, label: "Afficher les shops déjà faits" },
  { value: "3", label: "Masquer faits sur 3 derniers mois" },
  { value: "6", label: "Masquer faits sur 6 derniers mois" },
  { value: "12", label: "Masquer faits sur 12 derniers mois" },
  { value: ALL_ORDERS, label: "Masquer faits sur toutes les commandes" },
];

const SELECT_CLASS = "h-8 rounded-md border bg-background px-2 text-sm";

export function PiiBackfillFilters({
  filters,
  onChange,
  visibleCount,
  selectedCount,
  onSelectVisible,
  onClearSelection,
}: {
  filters: BackfillFilters;
  onChange: (filters: BackfillFilters) => void;
  visibleCount: number;
  selectedCount: number;
  onSelectVisible: () => void;
  onClearSelection: () => void;
}) {
  const set = (key: keyof BackfillFilters, value: string) =>
    onChange({ ...filters, [key]: value });

  return (
    <div className="flex flex-wrap items-center gap-2">
      <Input
        placeholder="Rechercher un shop"
        value={filters.search}
        onChange={(event) => set("search", event.target.value)}
        className="h-8 w-56"
      />
      <select
        value={filters.status}
        onChange={(event) => set("status", event.target.value)}
        className={SELECT_CLASS}
      >
        <option value={ALL_STATUSES}>Tous les statuts</option>
        {Object.entries(BACKFILL_STATUSES).map(([status, label]) => (
          <option key={status} value={status}>
            {label}
          </option>
        ))}
      </select>
      <select
        value={filters.hideCovered}
        onChange={(event) => set("hideCovered", event.target.value)}
        className={SELECT_CLASS}
      >
        {COVERED_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <Input
        type="number"
        min={0}
        placeholder="Commandes max"
        value={filters.maxOrders}
        onChange={(event) => set("maxOrders", event.target.value)}
        className="h-8 w-36"
      />
      <Button size="sm" variant="outline" onClick={onSelectVisible}>
        Sélectionner les {visibleCount} affichés
      </Button>
      <Button
        size="sm"
        variant="ghost"
        disabled={selectedCount === 0}
        onClick={onClearSelection}
      >
        Vider la sélection
      </Button>
    </div>
  );
}
